import type { Spec } from './catalog';

/**
 * Returns the keys of the root element's children in the Spec.
 * Returns an empty array if spec is null/undefined or the root element has no children.
 */
export function getRootChildKeys(spec: Spec | null | undefined): string[] {
  if (!spec) return [];
  const rootEl = spec.elements[spec.root];
  return rootEl?.children ?? [];
}
